import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Lê a feature flag `admin_cutover_enabled` de `public.platform_settings`.
 * Quando `true`, consumidores redirecionam /admin/* para admin.playprosport.com.br
 * e escondem items de sidebar.
 *
 * Fallback seguro: em qualquer erro de rede/auth, retorna `false` (não
 * redireciona — o paraquedas permanece). Staletime alto porque a flag
 * muda raramente.
 */
export function usePlatformCutoverFlag() {
  return useQuery({
    queryKey: ["platform", "cutover-flag"],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await supabase
        .from("platform_settings")
        .select("value")
        .eq("key", "admin_cutover_enabled")
        .maybeSingle();
      if (error) return false;
      const v = data?.value as { enabled?: boolean } | null;
      return Boolean(v?.enabled);
    },
  });
}

export const ADMIN_APP_URL = "https://admin.playprosport.com.br";
